<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form ref="searchForm">
                    <c-form-item type="datetime" label="评论时间" start-name="start_date" end-name="end_date"></c-form-item>
                    <c-form-item type="select" label="评论类型" :options="momentsTypeOptions" name="moments_type"></c-form-item>
                    <c-form-item type="input" label="评论内容" name="content"></c-form-item>
                    <c-form-item type="input" label="关联社区内容" name="comment_content"></c-form-item>
                    <c-form-item type="hidden" label="关联社区ID" name="moments_id"></c-form-item>
                    <c-form-item type="input" label="评论人" name="nick_name"></c-form-item>
                    <c-form-item type="checkbox"  name="is_valid" :options="isValidState" :value="['1']"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_moments_comment_edit" color="black" hollow @click="updateValid(1)">批量显示</c-button>
                <c-button power="b_moments_comment_edit" color="black" hollow @click="updateValid(0)">批量隐藏</c-button>
            </m-operate>

            <c-table ref="table">

                <c-table-column
                        type="selector"
                ></c-table-column>

                <c-table-column
                        label="评论类型"
                        name="commend_type"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.commend_type == -2">回复评论</span>
                        <span v-if="data.commend_type == -1">--</span>
                        <span v-if="data.commend_type == 3">话题跟帖评论</span>
                        <span v-if="data.commend_type == 5">分享评论</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="评论对象"
                        name="moments_target"
                        width="250"
                >
                </c-table-column>

                <c-table-column
                        label="评论人"
                        name="nick_name"
                        width="150"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="40" style="margin-right: 10px;"></c-image>
                            <div>
                                <span>{{data.nick_name||'--'}}</span></br>
                                <span style="color:blue">{{data.user_manage_mobilephone}}</span>
                            </div>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                        label="评论内容"
                        name="content"
                        width="250"
                >
                    <template v-slot="{data}">
                        <span class="ellipsis-2" :title="data.content">{{data.content}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="关联社区内容"
                        name="moments_title"
                        width="250"
                >
                    <template v-slot="{data}">
                        <span v-if="data.moments_title">{{data.moments_title}}</span>
                        <span v-else-if="data.moments_content">{{data.moments_content}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="显示/隐藏"
                        name="is_valid"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.is_valid == 1"><span style="color:darkgreen">显示</span></span>
                        <span v-else><span style="color:red">隐藏</span></span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="评论时间"
                        name="create_date"
                        width="140"
                >
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template v-slot="row">
                        <c-table-button power="b_moments_comment_edit" v-if="row.data.is_valid == 0"  @click="updateValid(1,row.data)">显示</c-table-button>
                        <c-table-button power="b_moments_comment_edit" v-if="row.data.is_valid == 1"  @click="updateValid(0,row.data)">隐藏</c-table-button>
                        <c-table-button power="b_moments_comment_edit" @click="deleteComment(row)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

    </page>
</template>

<script>
    export default {
        name: 'm_moments_comment',

        props: {
            comment_id: String
        },

        data() {
            return {
                isValidState: [{
                    name: '显示中',
                    value: '1'
                },{
                    name: '已隐藏',
                    value: '0'
                },
                ],
                momentsTypeOptions:[
                    {
                        name:'话题跟帖评论',
                        value:3
                    },{
                        name:'分享评论',
                        value:5
                    },{
                        name:'回复评论',
                        value:-2
                    }
                ]
            }
        },

        watch: {
            comment_id(){
                if (this.comment_id){
                    //查询话题详情
                    this.request({
                        url: '/moments/detail',
                        data: {
                            id: this.comment_id
                        },
                        success: data => {
                            let param = {}
                            param.moments_type = data.moments_type;
                            param.moments_id = this.comment_id;
                            param.is_valid = [];
                            this.$refs.searchForm.set(param);
                            this.$nextTick(() => {
                                this.$refs.search.search();
                            })
                        }
                    });
                }
            }
        },

        computed: {

        },

        mounted() {
            if(this.comment_id){
                let param = {}
                param.moments_id = this.comment_id;
                param.is_valid = [];
                this.$refs.searchForm.set(param);
                this.$nextTick(() => {
                  this.$refs.search.search();
                })
               /* //查询话题详情
                this.request({
                    url: '/moments/detail',
                    data: {
                        id: this.comment_id
                    },
                    success: data => {
                        param.moments_type = data.moments_type;

                    }
                });*/
            }else{
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }

            this.$bus.$on('momentsTopicFollow.vue.update', () => {
                this.$refs.search.search();
            });
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/moments_comment/list',
                    data
                });
            },


            updateValid(type, item) {
                var list = item ? [{
                    data: item
                }] : this.$refs.table.getRow('selected');
                if (!list.length) {
                    this.$message({
                        text: '请选择要操作的内容'
                    });
                    return;
                }

                this.$confirm({
                    text: '确定要'+(type==1?'显示':'隐藏')+ (item ? '该' : '所选') +'内容吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/moments_comment/batch_edit_valid_state',
                            data: {
                                ids: Array.from(list, item => item.data.id),
                                is_valid:type
                            },
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

            deleteComment(item) {
                this.$confirm({
                    text: '确定要删除此评论吗？',
                    resolve: () => {
                        this.request({
                            url: '/moments_comment/del',
                            data: {
                                id: item.data.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '删除成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },



        }
    }
</script>